import axios from 'axios';
import { ProviderModel } from '../models/provider';

export const getProviders = async (
    ids: number[]
): Promise<ProviderModel[]> => {
    const response = await axios.post(
        '/api/provider',
        ids
    );
    return response.data;
};

export const getOtherProviders = async (
    ids: number[]
): Promise<ProviderModel[]> => {
    const response = await axios.post(
        '/api/provider/other',
        ids
    );
    return response.data;
};
